/** @format */
import { Injectable } from '@angular/core';
import { TranslationMarkupRendererFactory } from 'ngx-transloco-markup';
import { HtmlElementTranspiler } from '../common/html-element-transpiler';

export const STRONG_START = new (class StrongStart {})();
export const STRONG_END = new (class StrongEnd {})();

@Injectable()
export class StrongTranspiler extends HtmlElementTranspiler {
    constructor(private readonly rendererFactory: TranslationMarkupRendererFactory) {
        super({
            rendererFactory,
            start: {
                search: '<strong>',
                token: STRONG_START,
            },
            end: {
                search: '</strong>',
                token: STRONG_END,
            },
            elementTag: 'strong',
        });
    }
}
